import * as Yup from 'yup';
import { BSToADConvert } from '../../../../../widgets/DateFormat';

export const validationSchema2 = Yup.object().shape({
    first_name: Yup.string()
        .min(2, "First name must be at least 2 characters")
        .max(55, "First name must be at most 55 characters")
        .required("Enter First Name"),
    middle_name: Yup.string()
        .min(2, "Middle name must be at least 2 characters")
        .max(55, "Middle name must be at most 55 characters")
        .notRequired(),
    last_name: Yup.string()
        .min(2, "Last name must be at least 2 characters")
        .max(55, "Last name must be at most 55 characters")
        .required("Please enter Last Name"),
    dobn: Yup.string()
        .required("Please enter DOB (BS)")
        .test("is-valid-date", "Invalid DOB format", value => {
            if (!value) return false;

            // Check format like YYYY/MM/DD
            return /^\d{4}\/\d{2}\/\d{2}$/.test(value);
        })
        .test("not-in-future", "DOB cannot be in the future", value => {
            if (!value) return false;

            // Convert BS to AD (if you have a converter)
            const adDate = BSToADConvert(value); // You need to define or import this
            const today = new Date();

            return new Date(adDate) <= today;
        })
        .test("age-minimum", "Age must be at least 5 years", value => {
            if (!value) return false;

            const adDate = BSToADConvert(value);
            const dob = new Date(adDate);
            const today = new Date();

            const age = today.getFullYear() - dob.getFullYear();
            return age >= 5;
        }),

    name_nep: Yup.string()
        .required("Please enter Nepali Name"),

    gender: Yup.string()
        .required("Please enter Gender"),
    marital_status: Yup.string()
        .required("Please enter Marital Status"),
    disability: Yup.boolean(),
    disability_type: Yup.string().when("disability", {
        is: true,
        then: (schema) => schema.required("Disability type is required"),
    }),
    phone: Yup.string()
        .matches(/^\d{10}$/, "Phone number must be a 10-digit number")
        .required("Please enter a Phone Number"),
    nationality: Yup.string()
        .min(2, "Nationality must be at least 2 characters")
        .max(30, "Nationality must be at most 30 characters")
        .required("Please enter Nationality"),
    edg: Yup.string()
        .required("Please select EDG"),
    caste: Yup.string()
        .required("Please select Ethnicity"),
    sub_caste: Yup.string()
        .required("Please select Caste"),
    religion: Yup.string()
        .required("Please select Religion"),
});
export const validationSchema1 = Yup.object({
    program: Yup.string().required("Select program Name"),
    acdmc_year: Yup.string().required("Select academics year Name"),
    sec: Yup.string().required("Select section Name"),
    shift: Yup.string().required("Select shift Name"),
    medium: Yup.string().required("Select medium Name"),
    team: Yup.string().required("Select team Name"),
    year_semester: Yup.string().required("Select year/semester Name"),
});

export const validationSchema4 = Yup.object().shape({
    province: Yup.string().required("Province is required"),
    district: Yup.string().required("District is required"),
    municipality: Yup.string().required("Municipality is required"),
    wardno: Yup.number()
        .typeError("Ward number must be a number")
        .required("Ward number is required"),

    tole: Yup.string().nullable(),
    house_no: Yup.string().nullable(),
    add_nep: Yup.string().nullable(),

    // For Current Address
    samePermanent: Yup.boolean(),

    // Conditional fields: only required when samePermanent is false
    t_province: Yup.string().when("samePermanent", {
        is: false,
        then: (schema) => schema.required("Province is required"),
    }),
    t_district: Yup.string().when("samePermanent", {
        is: false,
        then: (schema) => schema.required("District is required"),
    }),
    t_municipality: Yup.string().when("samePermanent", {
        is: false,
        then: (schema) => schema.required("Municipality is required"),
    }),
    t_wardno: Yup.number().when("samePermanent", {
        is: false,
        then: (schema) =>
            schema
                .typeError("Ward number must be a number")
                .required("Ward number is required"),
    }),

    t_tole: Yup.string().nullable(),
    t_house_no: Yup.string().nullable(),
});


export const validationSchema3 = Yup.object({
    mother_qualification: Yup.string()
        .required("Please select Mother's Qualification"),
    father_qualification: Yup.string()
        .required("Please select Father's Qualification"),
    father_name: Yup.string()
        .min(2, "Father's name must be at least 2 characters")
        .max(60, "Father's name must be at most 60 characters")
        .required("Please enter Father's Name"),
    mother_name: Yup.string()
        .min(2, "Mother's name must be at least 2 characters")
        .max(60, "Mother's name must be at most 60 characters")
        .required("Please enter Mother's Name"),
    guardian_name: Yup.string()
        .min(2, "Guardian name must be at least 2 characters")
        .max(60, "Guardian name must be at most 60 characters")
        .required("Please enter Guardian Name"),
    guardian_phone: Yup.string()
        .matches(/^\d{10}$/, "Guardian Phone number must be a 10-digit number")
        .required("Please enter a Guardian Phone Number"),

});


